module.exports = __webpack_public_path__ + "img/visualizar-resposta-tabela-formulario2.276febd7.png";